import { Box, Grid, GridItem, Text } from '@chakra-ui/react';
import React from 'react';

import {
  BorrowingBaseSummaryColumnValueInput,
  getTemplateColumnsForAccordionRow,
} from 'packages/borrowing-base/ui/borrowingBaseSummary/utils';
import { colors } from 'packages/common-frontend/colors';

export const VerificationApproveTablesStickyHeader: React.FC<{
  borrowingBaseReportsDates: BorrowingBaseSummaryColumnValueInput;
}> = ({ borrowingBaseReportsDates }) => {
  const templateColumns = getTemplateColumnsForAccordionRow({
    showComparisonAndDifferenceColumns: true,
  });

  return (
    <Box
      padding="8px 16px"
      height="100%"
      width="100%"
      position="sticky"
      zIndex="100" // some high z-index to ensure nothing in the children render on top on scroll (eg. popovers)
      top="0"
      backgroundColor="white"
      borderBottomWidth="1px"
    >
      <Grid minH="48px" templateColumns={templateColumns} gap="16px">
        <GridItem colSpan={1} alignSelf="center" />

        <GridItem
          colSpan={1}
          alignSelf="center"
          padding="8px 16px"
          backgroundColor={colors.background[50]}
        >
          <Text fontSize="16px" fontWeight={500} textAlign="left">
            Prior Week Final
            <br />
            {borrowingBaseReportsDates.referenceValue}
          </Text>
        </GridItem>

        <GridItem
          colSpan={1}
          alignSelf="center"
          padding="8px 16px"
          backgroundColor={colors.background[50]}
        >
          <Text fontSize="16px" fontWeight={500} textAlign="left">
            Borrower Submitted
            <br />
            {borrowingBaseReportsDates.subtrahendValue}
          </Text>
        </GridItem>

        <GridItem
          colSpan={1}
          alignSelf="center"
          padding="8px 16px"
          backgroundColor={colors.background[50]}
        >
          <Text fontSize="16px" fontWeight={500} textAlign="left">
            Finley Agent
            <br />
            {borrowingBaseReportsDates.minuendValue}
          </Text>
        </GridItem>

        <GridItem
          colSpan={1}
          alignSelf="center"
          padding="8px 16px"
          backgroundColor={colors.background[50]}
        >
          <Text fontSize="16px" fontWeight={500} textAlign="left">
            Differences
            <br />
            {borrowingBaseReportsDates.subtrahendValue}
          </Text>
        </GridItem>
      </Grid>
    </Box>
  );
};
